module.exports = __webpack_public_path__ + "img/approve-reservation.53f1c079.svg";